import React, {useState} from 'react'
import {BrowserRouter, Switch, Route} from 'react-router-dom'

import {
  ApiServiceContext,
  PreloaderContext,
  StorageContext,
  BasketContext
} from '../context'
import ApiService from '../../utils/apiService'
import StorageService from '../../utils/storageService'

import '../../resources/css/normalize.css'
import '../../resources/css/font-awesome.min.css'
import '../../resources/css/style.css'
import '../../resources/css/style-catalogue.css'
import '../../resources/css/style-order.css'
import '../../resources/css/style-product-card.css'
import '../../resources/css/style-favorite.css'

import Header from '../header'
import Footer from '../footer'
import Main from '../pages/main'
import Catalogue from '../pages/catalogue'
import Favorite from '../pages/favorite'
import Order from '../pages/order'
import OrderDone from '../pages/order-done'
import ProductCardDesktop from '../pages/product-card-desktop'
import Preloader from '../preloader'
import ErrorCatcher from "../error-catcher";

const apiService = new ApiService();
const storage = new StorageService();

const App = () => {
  const
    [preloader, setPreloader] = useState(false),
    [basket, setBasket] = useState([]),
    [cartId, setCartId] = useState('');

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL+'/'}>
      <ErrorCatcher>
        <ApiServiceContext.Provider value={apiService}>
          <div className="container">
            <PreloaderContext.Provider value={setPreloader}>
              <Preloader visible={preloader}/>
              <BasketContext.Provider value={{cartId, setCartId, basket, setBasket}}>
                <Header/>
                <StorageContext.Provider value={storage}>
                  <Switch>
                    <Route path='/catalogue' component={Catalogue}/>
                    <Route path='/favorite' component={Favorite}/>
                    <Route path='/order' component={Order}/>
                    <Route path='/order-done' component={OrderDone}/>
                    <Route path='/product-card-desktop/:id' component={ProductCardDesktop}/>
                    <Route path='/' component={Main}/>
                  </Switch>
                </StorageContext.Provider>
              </BasketContext.Provider>
              <Footer/>
            </PreloaderContext.Provider>
          </div>
        </ApiServiceContext.Provider>
      </ErrorCatcher>
    </BrowserRouter>
  )
};

export default App
